export default {
  name: 'editCustomerInfor',
  data() {
    return {
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      totalRows: 100,
      provinceData: [],
      industryData: [],
      cityData: [],
      areaData: [],
      dialogTitle: {
        addCustInfor: '新增企业客户信息',
        editCustInfor: '编辑企业客户信息'
      },
      off: 'off',
      login: [],
      infoEssential: {
        custName: '',
        custId: '',
        custState: '1',
        custSourceId: '',
        custTypeId: '',
        custTypeTwoId: '',
        custSysIds: [],
        ipAddress: ''
      },
      contactsInfo: {
        contacts: '',
        custId: '',
        conPhone: '',
        conMail: '',
        sex: '1',
        post: '',
        date: ''
      },
      detailCustInfor: {
        gradeCode: '',
        custId: '',
        industry: '',
        idenType: '',
        idenNum: '',
        ipaddress: '',
        desc: '',
        area: '',
        city: '',
        province: ''
      },
      activeName: 'first',
      dialogStatus: '',
      editCustInfor: {
        custTypeId: '',
        sex: '1',
        post: '',
        date: '',
        cusGrade: '',
        industry: '',
        idenType: '',
        idenNum: '',
        ipaddress: '',
        busMail: '',
        extFieldList: [
          {
            fieldName: '',
            fieldValue: ''
          }
        ],
        custTypeTwoId: '',
        custContractName: '',
        custPayName: '',
        custSourceId: '',
        custId: '',
        custName: '',
        custUserId: '',
        custType: '',
        custState: 1,
        custSysIds: [],
        ipAddress: '',
        contacts: '',
        conPhone: '',
        conMail: '',
        abuId: '',
        abuName: '',
        abuMobile: '',
        /* 账户信息 */
        accountDatas: [
          {
            accId: '',
            accName: '', // 客户账户名称
            accPwd: '', // 客户账户密码
            apiKey: '', // 特殊字段
            accStatus: '1' // 账户状态
          }
        ],
        contractEffectiveDate: '',
        /* 合同附件 */
        contractFiles: [
          // {
          //   name: '',
          //   url: ''
          // }
          /* {
            contractFileUrl: '',
            contractFileName: ''
          } */
        ]
      },
      typeOneData: [],
      typeTwoData: [],
      source: [],
      /* 存储删除的账户信息 */
      accountDatas2: [],
      uploadFile: this.$API.fileUpload,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      rules: {
        custName: [
          {
            required: true,
            message: '请输入客户名称',
            trigger: ['blur', 'change']
          }
        ],
        idenNum: [
          {
            required: true,
            message: '请输入证件号码',
            trigger: ['blur', 'change']
          }
        ],
        date: [
          {
            required: true,
            message: '请选择生日',
            trigger: ['blur', 'change']
          }
        ],
        gradeCode: [
          {
            required: true,
            message: '请选择客户等级',
            trigger: ['blur', 'change']
          }
        ],
        idenType: [
          {
            required: true,
            message: '请选择证件类型',
            trigger: ['blur', 'change']
          }
        ],
        industry: [
          {
            required: true,
            message: '请选择所属行业',
            trigger: ['blur', 'change']
          }
        ],
        credit: [
          { required: true, message: '请输入授信额度', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        custSysIds: [
          {
            required: true,
            message: '请选择客户适用业务',
            trigger: ['blur', 'change']
          }
        ],
        // custUserId: [
        //   {
        //     required: true,
        //     message: '请选择登录名',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        custType: [
          {
            required: true,
            message: '请选择客户类型',
            trigger: ['blur', 'change']
          }
        ],
        contacts: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: ['blur', 'change']
          }
        ],
        conPhone: [
          {
            required: true,
            message: '请输入联系人号码',
            trigger: ['blur', 'change']
          },
          { validator: this.regular.phone, trigger: ['blur', 'change'] }
        ],
        conMail: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: ['blur', 'change']
          },
          { validator: this.regular.email, trigger: ['blur', 'change'] }
        ],
        custTypeId: [
          {
            required: true,
            message: '请选择客户类型',
            trigger: ['blur', 'change']
          }
        ],
        custContractName: [
          {
            required: true,
            message: '请输入客户合同名称',
            trigger: ['blur', 'change']
          }
        ],
        custPayName: [
          {
            required: true,
            message: '请输入客户打款名称',
            trigger: ['blur', 'change']
          }
        ],
        custSourceId: [
          {
            required: true,
            message: '请选择客户来源',
            trigger: ['blur', 'change']
          }
        ]
      },
      abuMobileBoolean: true,
      abuNameData: [],
      supLevelList: [],
      accountData: [],
      custTypeData: [],
      num: '',
      size: '',
      sysData: [],
      /* 账户状态 */
      accountStateData: [
        {
          id: '1',
          value: '有效'
        },
        {
          id: '0',
          value: '无效'
        }
      ],
      abuNameBlooen: false
    }
  },
  created() {
    let _this = this
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryIndustryCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      _this.industryData = data.industryInfos
    }).catch((error) => {
      console.log(error)
    })
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryGradeCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      this.supLevelList = data.gradeInfos
    }).catch((error) => {
      console.log(error)
    })
    this.queryDefaultList()
    this.dialogStatus = 'addCustInfor'
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
    /* 若是编辑页查询详情信息 */
    if (this.$route.query.custId) {
      this.dialogStatus = 'editCustInfor'
      this.queryEditDetail(this.$route.query.custId)
      this.queryContact(this.$route.query.custId)
      this.queryAccount(this.$route.query.custId)
      this.$http({
        method: 'get',
        url: _this.$API.supplier.queryAddrCode
      }).then((response) => {
        let data = response.data.resData
        _this.provinceData = data
        _this.queryDetail(_this.$route.query.custId)
        console.log(_this.provinceData)
      }).catch((error) => {
        console.log(error)
      })
      /* 查询商务经理列表 */
      let type = {abuType: 2}
      this.$axios
        .get(_this.$API.supplier.queryBusinessMangerList, {params: type})
        .then(function(r) {
          _this.abuNameData = r.data.resData.userList
          _this.queryBusiness(_this.$route.query.custId)
        })
        .catch(function(error) {})
      this.queryExtInfoById(this.$route.query.custId)
    }
  },
  methods: {
    queryDefaultList() {
      let _self = this
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      /* 查询客户来源 */
      this.$axios
        .get(this.$API.customerManagement.queryCustFromList)
        .then(function(r) {
          _self.source = r.data.resData
        })
        .catch(function(error) {})
      /* 查询客户类型1级 */
      this.$axios
        .get(this.$API.customerManagement.queryCustTypeFirst)
        .then(function(r) {
          _self.typeOneData = r.data.resData
        })
        .catch(function(error) {})
      /* 查询客户适应业务系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function(r) {
          _self.sysData = r.data.resData
        })
        .catch(function(error) {})
    },
    provinceChange (val) {
      console.log(val)
      console.log(this.provinceData)
      this.detailCustInfor.city = ''
      this.detailCustInfor.area = ''
      if (val && val !== 0) {
        for (let v of this.provinceData) {
          if (v.short_code === val) {
            console.log(v)
            this.cityData = v.city
          }
        }
      } else {
        this.cityData = []
        this.areaData = []
      }
      console.log(this.cityData)
    },
    cityChange (val) {
      console.log(val)
      console.log(this.cityData)
      this.detailCustInfor.area = ''
      if (val && val !== 0) {
        for (let v of this.cityData) {
          if (v.short_code === val) {
            this.areaData = v.area
          }
        }
      } else {
        this.areaData = []
      }
    },
    changeOne(val) {
      // 根据客户类型一级查二级
      let params = { parentCustTypeId: val }
      let _this = this
      this.infoEssential.custTypeTwoId = ''
      this.$axios
        .get(this.$API.customerManagement.queryCustTypeByParentCustTypeId, {
          params: params
        })
        .then(function(r) {
          _this.typeTwoData = r.data.resData
        })
        .catch(function(error) {})
    },
    /* 查询基本信息 */
    queryEditDetail(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.querycompCustInfoCtrInfoById, params)
        .then(function(r) {
          let data = r.data.resData
          console.log(data)
          // 如果有一级查询对应二级客户类型
          if (data.custTypeFirst) {
            _self.changeOne(data.custTypeFirst)
          }
          _self.infoEssential.custId = data.custId
          _self.infoEssential.custName = data.custName
          _self.infoEssential.custState = data.custState
          _self.infoEssential.custSourceId = data.custSourceId
          _self.infoEssential.custTypeId = data.custTypeFirst
          _self.infoEssential.custTypeTwoId = data.custTypeSecond
          _self.infoEssential.custSysIds = data.custSysIds ? data.custSysIds.split(',').map(Number) : []
          _self.infoEssential.ipaddress = data.ipaddress
        })
        .catch(function(error) {})
    },
    saveinfoEssential (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.infoEssential.custId
          op.custName = _this.infoEssential.custName
          op.custState = _this.infoEssential.custState
          op.custSourceId = _this.infoEssential.custSourceId
          op.custSysIds = _this.infoEssential.custSysIds ? _this.infoEssential.custSysIds.join(',') : ''
          op.ipaddress = _this.infoEssential.ipaddress
          op.custType = _this.infoEssential.custTypeTwoId ? _this.infoEssential.custTypeTwoId : _this.infoEssential.custTypeId
          console.log(op)
          _this.$axios
            .post(_this.$API.customerManagement.updateCompanyCustInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '更新企业客户基本信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 查询联系人信息 */
    queryContact(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryContactInfoById, params)
        .then(function(r) {
          let data = r.data.resData
          console.log(data)
          _self.contactsInfo.custId = data.custId
          _self.contactsInfo.contacts = data.contactName
          _self.contactsInfo.conPhone = data.contactTel
          _self.contactsInfo.conMail = data.contactMail
          _self.contactsInfo.sex = data.sex
          _self.contactsInfo.post = data.contactPosition
          _self.contactsInfo.date = data.birthday
          _self.contactsInfo.custId = data.custId
        })
        .catch(function(error) {})
    },
    saveContactsInfo (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.contactsInfo.custId
          op.contactName = _this.contactsInfo.contacts
          op.contactTel = _this.contactsInfo.conPhone
          op.contactMail = _this.contactsInfo.conMail
          op.sex = this.contactsInfo.sex
          op.contactPosition = _this.contactsInfo.post
          op.birthday = _this.contactsInfo.date
          _this.$axios
            .post(_this.$API.customerManagement.addContactInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '更新企业联系人信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 查询详细信息 */
    queryDetail(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.querycompDeatilById, params)
        .then(function(r) {
          let data = r.data.resData
          _self.detailCustInfor.custId = data.custId
          _self.detailCustInfor.gradeCode = data.custLevelCode
          _self.detailCustInfor.industry = data.industryCode
          _self.detailCustInfor.idenType = data.cardType
          _self.detailCustInfor.idenNum = data.cardNum
          _self.detailCustInfor.ipaddress = data.detailAddr
          _self.detailCustInfor.desc = data.introduce
          let where = null
          if (data.location) {
            where = data.location.split('-')
            console.log(where)
            _self.detailCustInfor.province = where[0]
            _self.provinceChange(where[0])
            _self.cityChange(where[1])
            _self.detailCustInfor.city = where[1]
            _self.detailCustInfor.area = where[2]
          }
          console.log(data)
        })
        .catch(function(error) {})
    },
    savedetailCustInfor (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.detailCustInfor.custId
          op.custLevelCode = _this.detailCustInfor.gradeCode
          op.industryCode = _this.detailCustInfor.industry
          op.cardType = _this.detailCustInfor.idenType
          op.industryCode = _this.detailCustInfor.industry
          op.cardNum = _this.detailCustInfor.idenNum
          op.detailAddr = _this.detailCustInfor.ipaddress
          op.introduce = _this.detailCustInfor.desc
          if (_this.detailCustInfor.province) {
            if (!_this.detailCustInfor.city || !_this.detailCustInfor.area) {
              _this.$message.error('地理位置请选择省市区!')
              return
            }
            op.location = _this.detailCustInfor.province + '-' + _this.detailCustInfor.city + '-' + _this.detailCustInfor.area
          } else {
            op.location = ''
          }
          _this.$axios
            .post(_this.$API.customerManagement.addCompCustInfoCtrDetailInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '更新企业客户详细信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 查询账户信息 */
    queryAccount(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryAccInfoById, params)
        .then(function(r) {
          let data = r.data.resData
          _self.editCustInfor.accountDatas = data.accList
          console.log(data)
        })
        .catch(function(error) {})
    },
    saveAccount (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.contactsInfo.custId
          op.accList = _this.editCustInfor.accountDatas.concat(
            _this.accountDatas2
          )
          for (let v of op.accList) {
            if (!v.deleted) {
              v.deleted = 0
            }
          }
          _this.$axios
            .post(_this.$API.customerManagement.updateAccInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.queryAccount(_this.contactsInfo.custId)
              _this.$message({
                type: 'success',
                message: '更新企业客户账户信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 查询商务经理信息 */
    queryBusiness(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryAbuInfoById, params)
        .then(function(r) {
          let data = r.data.resData
          _self.editCustInfor.abuName = data.abuId
          if (data.abuId) {
            for (let v of _self.abuNameData) {
              if (data.abuId === v.userId) {
                _self.changeTemplate(v)
              }
            }
          }
          console.log(data)
        })
        .catch(function(error) {})
    },
    saveBusiness (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.infoEssential.custId
          op.abuId = _this.editCustInfor.abuName
          _this.$axios
            .post(_this.$API.customerManagement.addAbuInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '更新企业客户商务信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 查询扩展信息 */
    queryExtInfoById(custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryExtInfoById, params)
        .then(function(r) {
          let data = r.data.resData
          _self.editCustInfor.extFieldList = data.extFieldList
          // for (let v of _self.editCustInfor.extFieldList) {
          //   v.name = v.fieldName
          //   v.value = v.fieldValue
          // }
          console.log(_self.editCustInfor.extFieldList)
        })
        .catch(function(error) {})
    },
    saveExtFieldList (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.custId = _this.infoEssential.custId
          op.extFieldList = _this.editCustInfor.extFieldList
          _this.$axios
            .post(_this.$API.customerManagement.addExtInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.queryExtInfoById(_this.infoEssential.custId)
              _this.$message({
                type: 'success',
                message: '更新企业客户扩展信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 选择商务经理联动商务经理电话 */
    changeTemplate(data) {
      // this.abuMobileBoolean = false
      this.editCustInfor.abuMobile = data.mobile
      this.editCustInfor.busMail = data.email
    },
    /* 如果商务经理没有选中清空商务经理电话 */
    clearAbuNameSel(data) {
      // this.abuMobileBoolean = true
      if (data === '') {
        this.editCustInfor.abuMobile = ''
        this.editCustInfor.abuId = ''
      }
    },
    /* 添加账户 */
    addAccount() {
      this.editCustInfor.accountDatas.push({
        accId: '',
        accName: '', // 客户账户名称
        accPwd: '', // 客户账户密码
        apiKey: '', // 特殊字段
        accStatus: '1' // 账户状态
      })
    },
    /* 删除账户 */
    removeAccount(item) {
      var index = this.editCustInfor.accountDatas.indexOf(item)
      if (index !== -1) {
        /* 对已存在的账户删除push到另一个数组 */
        if (item.accId) {
          item.deleted = 1
          this.accountDatas2.push(item)
        }
        this.editCustInfor.accountDatas.splice(index, 1)
      }
    },
    /* 添加扩展属性 */
    addExtField() {
      this.editCustInfor.extFieldList.push({
        fieldName: '',
        fieldValue: ''
      })
    },
    /* 删除扩展属性 */
    removeExtField(item) {
      var index = this.editCustInfor.extFieldList.indexOf(item)
      if (index !== -1) {
        this.editCustInfor.extFieldList.splice(index, 1)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      let url = file.url
      for (let i = 0; i < this.editCustInfor.contractFiles.length; i++) {
        if (this.editCustInfor.contractFiles[i].url === url) {
          this.editCustInfor.contractFiles.splice(i, 1)
        }
      }
    },
    success(response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        let op = {}
        op.name = response.resData.fileName
        op.url = response.resData.url
        this.editCustInfor.contractFiles.push(op)
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview(file) {
      /* 预览 TODO */
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(
        file.url,
        '_blank',
        'width=' +
          _width +
          ', height = ' +
          _height +
          ', menubar = no,toolbar = no, status = no, scrollbars = yes'
      )
      // const userAgent = navigator.userAgent
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   alert('推荐谷歌进行文件预览')
      // } else {
      //   window.open(file.url) // blob格式地址
      // }
    },
    /* 上传前校验大小限制 */
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 20
      /* if(!extension) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        });
      } */
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      return extension && isLt2M
    },
    /* 商务经理切换输入/选择 */
    switchAbuName() {
      this.abuNameBlooen = !this.abuNameBlooen
      this.editCustInfor.abuId = ''
      this.editCustInfor.abuName = ''
      this.editCustInfor.abuMobile = ''
    },
    /* 返回列表 */
    returnList() {
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        path: '/customerInfor',
        query: {
          num: this.num,
          size: this.size
        }
      })
    },
    /* 保存客户信息 */
    saveAccountInfor(formName) {
      /* 判断弹窗状态值, 编辑修改/新增保存 */
      if (this.dialogStatus == 'editCustInfor') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let arrAbuId = this.editCustInfor.abuId // 商务经理id
            let abuInfoObj = {}
            if (arrAbuId && this.editCustInfor.abuName && this.editCustInfor.abuName.trim()) {
              abuInfoObj.abuName = this.editCustInfor.abuName.trim()
              abuInfoObj.abuMobile = this.editCustInfor.abuMobile.trim()
            }
            let params = {
              custId: this.$route.query.custId, // 客户id
              custName: this.editCustInfor.custName, // 客户名称
              custUserId: this.editCustInfor.custUserId, // 客户登录用户id
              custType: this.editCustInfor.custTypeId, // 客户类型
              "custSourceId": this.editCustInfor.custSourceId,// 客户来源id
              "custPayName": this.editCustInfor.custPayName,
              "custContractName": this.editCustInfor.custContractName,
              custState: this.editCustInfor.custState, // 客户状态
              custSysIds: this.editCustInfor.custSysIds
                ? this.editCustInfor.custSysIds.join(',')
                : '', // 客户适用业务
              ipAddress: this.editCustInfor.ipAddress, // 客户报备ip
              contractEffectiveDate: this.editCustInfor.contractEffectiveDate
                ? this.editCustInfor.contractEffectiveDate[0]
                : '', // 合同有效期-起
              contractExpirationDate: this.editCustInfor.contractEffectiveDate
                ? this.editCustInfor.contractEffectiveDate[1]
                : '', // 合同有效期-止
              custAccounts: this.editCustInfor.accountDatas.concat(
                this.accountDatas2
              ), // 账户信息
              custContacts: {
                contacts: this.editCustInfor.contacts, // 联系人名称
                conPhone: this.editCustInfor.conPhone, // 联系人手机
                conMail: this.editCustInfor.conMail // 联系人邮箱
              },
              custAbuId: this.editCustInfor.abuId, // 客户商务经理id,空字符串为删除，含值为更新
              abuInfo: abuInfoObj,
              contractFiles: []
            }
            if (this.editCustInfor.custTypeTwoId) {
              params.custType = this.editCustInfor.custTypeTwoId
            } else {
              params.custType = this.editCustInfor.custTypeId
            }
            for (let v of this.editCustInfor.contractFiles) {
              let op = {}
              op.contractFileName = v.name
              op.contractFileUrl = v.url
              params.contractFiles.push(op)
            }

            let ipRule = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
              regVal = false,
              ipaddressVal = params.ipAddress
            /* 判断ip地址最后以为是否有";",有就去掉以便验证 */
            if (ipaddressVal.substr(ipaddressVal.length - 1, 1) == ';') {
              ipaddressVal = ipaddressVal.substring(0, ipaddressVal.length - 1)
            } else {
              ipaddressVal = ipaddressVal
            }
            let ipArry = ipaddressVal.split(';'),
              newIpArry = ipArry.sort(),
              ipSortBlooen = false
            /* 判断ip是否有值,有校验无跳过 */
            if (params.ipAddress.length) {
              ipArry.forEach(function(v) {
                if (v.match(ipRule) == null) {
                  regVal = true
                  return false
                }
              })
            } else {
              regVal = false
            }
            /* 对数组进行排序，查上一个和下一个是否相等 */
            for (let i = 0; i < ipArry.length; i++) {
              if (newIpArry[i] == newIpArry[i + 1]) {
                ipSortBlooen = true
              }
            }
            // 校验ip地址列表是否重复
            if ((params.ipAddress && !ipSortBlooen) || !params.ipAddress) {
              this.$axios
                .post(this.$API.customerManagement.updateCustInfo, params)
                .then(function(r) {
                  _self.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  _self.$store.commit('closeTab', _self.$route) // 关闭当前路由
                  _self.$router.push({
                    path: '/customerInfor'
                  })
                })
                .catch(function(error) {})
            } else {
              this.$message({
                type: 'warning',
                message: 'IP输入重复，请修改后保存'
              })
            }
          }
        })
      } else if (this.dialogStatus == 'addCustInfor') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let arrAbuId = this.editCustInfor.abuId // 商务经理id
            let abuInfoObj = {}
            if (arrAbuId && this.editCustInfor.abuName && this.editCustInfor.abuName.trim()) {
              abuInfoObj.abuName = this.editCustInfor.abuName.trim()
              abuInfoObj.abuMobile = this.editCustInfor.abuMobile.trim()
            }
            let params = {
              custName: this.editCustInfor.custName, // 客户名称
              custUserId: this.editCustInfor.custUserId, // 客户登录用户id
              custType: this.editCustInfor.custTypeId, // 客户类型
              "custSourceId": this.editCustInfor.custSourceId,// 客户来源id
              "custPayName": this.editCustInfor.custPayName,
              "custContractName": this.editCustInfor.custContractName,
              custState: this.editCustInfor.custState, // 客户状态
              custSysIds: this.editCustInfor.custSysIds
                ? this.editCustInfor.custSysIds.join(',')
                : '', // 客户适用业务
              ipAddress: this.editCustInfor.ipAddress, // 客户报备ip
              contractEffectiveDate: this.editCustInfor.contractEffectiveDate
                ? this.editCustInfor.contractEffectiveDate[0]
                : '', // 合同有效期-起
              contractExpirationDate: this.editCustInfor.contractEffectiveDate
                ? this.editCustInfor.contractEffectiveDate[1]
                : '', // 合同有效期-止
              custAccounts: this.editCustInfor.accountDatas.concat(
                this.accountDatas2
              ), // 账户信息
              custContacts: {
                contacts: this.editCustInfor.contacts, // 联系人名称
                conPhone: this.editCustInfor.conPhone, // 联系人手机
                conMail: this.editCustInfor.conMail // 联系人邮箱
              },
              custAbuId: this.editCustInfor.abuId, // 客户商务经理id,空字符串为删除，含值为更新
              abuInfo: abuInfoObj,
              contractFiles: []
            }
            if (this.editCustInfor.custTypeTwoId) {
              params.custType = this.editCustInfor.custTypeTwoId
            } else {
              params.custType = this.editCustInfor.custTypeId
            }
            for (let v of this.editCustInfor.contractFiles) {
              let op = {}
              op.contractFileName = v.name
              op.contractFileUrl = v.url
              params.contractFiles.push(op)
            }

            let ipRule = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
              regVal = false,
              ipaddressVal = params.ipAddress
            /* 判断ip地址最后以为是否有";",有就去掉以便验证 */
            if (ipaddressVal.substr(ipaddressVal.length - 1, 1) == ';') {
              ipaddressVal = ipaddressVal.substring(0, ipaddressVal.length - 1)
            } else {
              ipaddressVal = ipaddressVal
            }
            let ipArry = ipaddressVal.split(';'),
              newIpArry = ipArry.sort(),
              ipSortBlooen = false
            /* 判断ip是否有值,有校验无跳过 */
            if (params.ipAddress.length) {
              ipArry.forEach(function(v, index) {
                if (v.match(ipRule) == null) {
                  regVal = true
                  return false
                }
              })
            } else {
              regVal = false
            }
            /* 对数组进行排序，查上一个和下一个是否相等 */
            for (let i = 0; i < ipArry.length; i++) {
              if (newIpArry[i] == newIpArry[i + 1]) {
                ipSortBlooen = true
              }
            }
            // 校验ip地址列表是否重复
            if ((params.ipAddress && !ipSortBlooen) || !params.ipAddress) {
              this.$axios
                .post(this.$API.customerManagement.addCustInfo, params)
                .then(function(r) {
                  _self.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  _self.$store.commit('closeTab', _self.$route) // 关闭当前路由
                  _self.$router.push({
                    path: '/customerInfor'
                  })
                })
                .catch(function(error) {})
            } else {
              this.$message({
                type: 'warning',
                message: 'IP输入重复，请修改后保存'
              })
            }
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customerManagement/addCustomerInfor.js